/**
 * @file Defines the {@link Debounce} class
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /** Prevent firing of a given function with a given time period */
 export class Debounce {

    /**
     * Debounce time period in ms
     * @memberof Debounce
     * @private
     * @instance
     * @type {number}
     */
    _debounce

    /**
     * Whether function is currently debouncing or not
     * @memberof Debounce
     * @protected
     * @instance
     * @type {boolean}
     */
    _fire

    /**
     * Function to debounce
     * @memberof Debounce
     * @private
     * @instance
     * @type {function}
     */
    _func

    /**
     * Initialize debounce.
     * @param {function} func_            - Function to debounce
     * @param {number}   [debounce_=null] - Amount to debounce by
     */
    constructor(func_, debounce_ = null) {

        //Initialize function to debounce
        this._func = func_

        //Initialize debounce period
        this._debounce = debounce_ ? debounce_ : 250

        //Set flag to indicate function is debouncing
        this._fire = true
        
    }

    /**
     * Execute a debounce period
     * @return {Promise<undefined>} Promise for once debounce period over
     */
    debounce() {

        //Promise for debounce
        return new Promise(resolve => {

            //Wait for debounce period
            setTimeout(() => {

                this._fire = true //Re-enable firing
                resolve()         //Resolve Promise

            }, this._debounce)

        })

    }


    /**
     * Attempt to execute function
     * @param {*} args_ - Functon arguments
     */
    fire(args_) {

        //Check if debouncing
        if (this._fire) {

            this._fire = false //Begin debounce period
            this.debounce()    //Perform debounce
            this._func(args_)  //Execute function

        }

    }

 }